import type { PickStatus } from '@modules/core/enums';
import type { ITableState } from '@modules/tables/types';

export type IDownloadListReportPayload = Partial<ITableState>;

export enum EDownloadReportTypes {
  CSV = 'csv',
  XLSX = 'xlsx',
}

export interface IDownloadReportListItem {
  id: number;
  creator_type: string;
  creator_id: number;
  request_timestamp: string;
  aasm_state: PickStatus<'READY' | 'IN_PROGRESS'>;
  report_type: string;
  creator_email: string;
  created_at: string;
  report_file_name: string;
  report_content_type?: string;
}

export interface IDownloadReportLinkResponse {
  link: string;
}

export interface IDownloadReportPayload {
  id: number;
  format: EDownloadReportTypes;
}
